import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './scoreboard-db-step2.hbs'
import formHelper from 'scoreboard/components/form-helper'
import FormView from 'scoreboard/components/form-view'
import DatabaseConfiguration from './database-configuration'
import i18n from 'scoreboard/components/i18n'

var ScoreboardDbStep2 = Backbone.View.extend({

	// this.model is a Database

	tagName: 'form',

	className: 'connection-wizard',

	initialize: function(options) {
		this.options = options || {}

		// set default port if necessary
		if (!this.model.get('port')) {
			var port = this.model.get('product') === 'mysql' ? '3306' : '1433'
			this.model.set('port', port)
		}

		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.empty().append(template(this.model.attributes))

		this.databaseConfiguration = new DatabaseConfiguration({
			model: this.model
		})
		this.$('.dialog-body-content').append(this.databaseConfiguration.el)
		this.databaseConfiguration.render()

		this.options.wizard.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})

		this.formView.start()

		// if an error needs to be displayed, probably after saving bad db info
		// must go after this.formView.start()
		if (this.options.message) {
			this.formView.errorMessage(this.options.message)
		}

		return this
	},

	saveState: function() {
		this.model.set(formHelper.readFromDom(this.el))
	},

	submit: function(e) {
		let database = _.extend({}, this.options.model.attributes, formHelper.readFromDom(this.el))
		// always delete the url when editing a database connection, so we don't try to connect to the old db
		if (!this.options.model.isNew()) {
			delete database.url
		}
		$.post({
			url: 'api/admin/databases/validate',
			data: JSON.stringify(database),
			success: () => {
				this.saveState()
				if (this.model.get('type') === 'scoreboard') {
					this.options.wizard.next()
				} else {
					this.options.wizard.finish()
					this.listenTo(this.options.wizard, 'done', this.trigger.bind(this, 'done'))
					// important: goes before the extra connection-error listener below
					this.listenTo(this.options.wizard, 'error connection-error',
						this.formView.start.bind(this.formView))
					this.listenTo(this.options.wizard, 'connection-error', function(options) {
						this.formView.errorMessage(options.message)
					}.bind(this))
				}
			},
			error: xhr => {
				const messageCode = _.get(xhr, 'responseJSON.messageCode')
				if (messageCode === 'admin.mapper.databaseConnection.mysqlSystemDatabaseError') {
					const args = _.get(xhr, 'responseJSON.arguments')
					const errorMessage = i18n.highlight(messageCode, args[0])
					this.formView.errorMessage(errorMessage)
					return
				}
				this.formView.error(xhr)
			}
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.wizardProgress, this.formView, this.databaseConfiguration], 'remove')
		_.invokeMap(this._markedFields, 'remove')
	}

})

export default ScoreboardDbStep2

ScoreboardDbStep2.__filename__ = 'admin/connections/scoreboard-db-step2.js'
